/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-08-21 09:38:46
 * @LastEditors: wl
 * @LastEditTime: 2020-08-21 09:55:32
 */
import axios from '../axios'
// 预警类型  strategy_type_list
export const handleQuery = (data) => {
  return axios({
    url: '/admin/service/sys_reportRepair_list',
    method: 'post',
    data
  })
}
///admin/service/sys_report_repair_read
//查询网格报事
export const tq_event_list = (data) => {
  return axios({
    url: '/admin/service/tq_event_list',
    method: 'post',
    data
  })
}
//查询网格报事
export const tq_get_appealLog = (data) => {
  return axios({
    url: '/admin/service/tq_get_appealLog',
    method: 'post',
    data
  })
}
export const handleGo = (data) => {
  return axios({
    url: '/admin/service/sys_reportRepair_management',
    method: 'post',
    data
  })
}
//投诉建议
export const complaint_delete = (data) => {
  return axios({
    url: '/admin/service/complaint_delete',
    method: 'post',
    data
  })
}

//咨询求助
export const sys_consultationAndhelp_list = (data) => {
  return axios({
    url: '/admin/service/sys_consultationAndhelp_list',
    method: 'post',
    data
  })
}
//咨询求助删除
export const consultationAndhelp_delete = (data) => {
  return axios({
    url: '/admin/service/consultationAndhelp_delete',
    method: 'post',
    data
  })
}
//咨询求助回复

export const sys_consultationAndhelp_management = (data) => {
  return axios({
    url: '/admin/service/sys_consultationAndhelp_management',
    method: 'post',
    data
  })
}

//咨询求助阅读

export const sys_consultationAndhelp_read = (data) => {
  return axios({
    url: '/admin/service/sys_consultationAndhelp_read',
    method: 'post',
    data
  })
}
//报事报修更新
export const sys_repair_update = (data) => {
  return axios({
    url: '/admin/service/sys_repair_update',
    method: 'post',
    data
  })
}
//投诉建议回复
export const sys_complaint_update = (data) => {
  return axios({
    url: '/admin/service/sys_complaint_update',
    method: 'post',
    data
  })
}
// 微心愿回复
export const updateContentArray = (data) => {
  return axios({
    url: '/admin/service/updateContentArray',
    method: 'post',
    data
  })
}
//报事报修更新
export const sys_soundofparty_read = (data) => {
  return axios({
    url: '/admin/service/sys_soundofparty_read',
    method: 'post',
    data
  })
}
//在线办理回复
export const wx_online_update = (data) => {
  return axios({
    url: '/admin/service/wx_online_update',
    method: 'post',
    data
  })
}

//问答回复

export const community_Q_list = (data) => {
  return axios({
    url: '/admin/service/community_Q&A_list',
    method: 'post',
    data
  })
}

//评论
export const community_Q= (data) => {
  return axios({
    url: '/admin/service/community_Q&A',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/repair.js